import React, { createRef, useEffect, useState } from 'react';
import { differenceInMonths, format as dateFnsFormat, parse as dateFnsParse } from 'date-fns';

import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import './date_range_picker_styles.css';
import { DateUtils } from 'react-day-picker';

export interface Props {
  onFromChange: (from: Date) => void;
  onToChange: (to: Date) => void;
}

function parseDate(str: string, format: string, locale: any) {
  const parsed = dateFnsParse(str, format, new Date(), { locale });
  if (DateUtils.isDate(parsed)) {
    return parsed;
  }
  return undefined;
}

function formatDate(date: number | Date, format: string, locale: any) {
  return dateFnsFormat(date, format, { locale });
}

export const DateRangePicker = (props: Props) => {
  const toDatePickerRef = createRef<DayPickerInput>();

  const [from, setFrom] = useState<any>(undefined);
  const [to, setTo] = useState<any>(undefined);

  // Show from month.
  useEffect(() => {
    if (from && differenceInMonths(to, from) < 2) {
      toDatePickerRef.current?.getDayPicker().showMonth(from);
    }
  }, [from]);

  const changeFrom = (newFrom: any) => {
    // Change the from date and focus the "to" input field
    setFrom(newFrom);
    props.onFromChange(newFrom);
  };

  const changeTo = (newTo: any) => {
    setTo(newTo);
    props.onToChange(newTo);
  };

  const modifiers = { start: from, end: to };
  return (
    <div className="InputFromTo">
      <DayPickerInput
        value={from}
        placeholder="From"
        format="dd-MM-yyyy"
        formatDate={formatDate}
        parseDate={parseDate}
        dayPickerProps={{
          selectedDays: [from, { from, to }],
          disabledDays: { after: to },
          toMonth: to,
          modifiers,
          numberOfMonths: 2,
          onDayClick: () => toDatePickerRef.current?.getInput().focus(),
        }}
        onDayChange={changeFrom}
      />{' '}
      —{' '}
      <span className="InputFromTo-to">
        <DayPickerInput
          ref={toDatePickerRef}
          value={to}
          placeholder="To"
          format="dd-MM-yyyy"
          formatDate={formatDate}
          parseDate={parseDate}
          dayPickerProps={{
            selectedDays: [from, { from, to }],
            disabledDays: { before: from },
            modifiers,
            month: from,
            fromMonth: from,
            numberOfMonths: 2,
          }}
          onDayChange={changeTo}
        />
      </span>
      <button
        onClick={() => { changeFrom(null); changeTo(null); }}  
        style={{
          display: from || to ? 'block' : 'none',
          fontSize: '.8rem',
          background: '#fff',
          borderRadius: '.4rem',
          marginTop: '.3rem',
          padding: '0 .4rem',
          cursor: 'pointer'}}>Clear</button>
    </div>
  );
};
